import { NgModule } from '@angular/core';

import { MatCardModule } from '@angular/material/card'
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgDompurifyModule } from '@tinkoff/ng-dompurify';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CurrencyPipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import {MatIconModule } from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatStepperModule} from '@angular/material/stepper';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MatMomentDateModule,
} from '@angular/material-moment-adapter';

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';

import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiCallService } from './api/service/api-call.service';
import { AuthInterceptor } from './api/interceptor/auth.interceptor';

import { QuoteDetailsComponent } from './pages/kenya/quote-details/quote-details.component';
import { KycComponent } from './pages/kenya/kyc/kyc.component';
import { YearDateFormatDirective } from './directive/year-date-format.directive';
import { FULL_FORMAT, FullYearDateFormatDirective } from './directive/full-year-date-format.directive';
import { ClaimDetailsComponent } from './pages/kenya/claims/claim-details/claim-details.component';
import { ClaimComponent } from './pages/kenya/claims/claim/claim.component';
import { Page2Component } from './pages/kenya/claims/claim-details/page2/page2.component';
import { Page3Component } from './pages/kenya/claims/claim-details/page3/page3.component';
import { Page4Component } from './pages/kenya/claims/claim-details/page4/page4.component';
import { QuoteDetailsUGComponent } from './pages/uganda/quote-details/quote-details.component';
import { ClaimDetailsComponentUG } from './pages/uganda/claim-details/claim-details.component';
import { ConfirmComponent } from './components/dialog/confirm/confirm.component';
import { BrowserModule } from '@angular/platform-browser';
import { BenefitsComponent } from './pages/tanzania/benefits/benefits.component';
import { DetailsTZComponent } from './pages/tanzania/detailsTZ/detailsTZ.component';
import { ClaimComponentTZ } from './pages/tanzania/claim/claim.component';
import { TheftDetailsComponent } from './pages/kenya/claims/theft-details/theft-details.component';
import { PesapalWebhookComponent } from './pages/kenya/pesapal-webhook/pesapal-webhook.component';
import { PesapalPayComponent } from './pages/kenya/pesapal-pay/pesapal-pay.component';
import { FnolComponent } from './pages/kenya/claims/fnol/fnol.component';
import { DetailsComponent } from './pages/kenya/claims/details/details.component';

import { ToastrModule } from 'ngx-toastr';
import { SspLoginComponent } from './pages/uganda/ssp-login/ssp-login.component';
import { BuyComponent } from './pages/tanzania/third-party/buy/buy.component';
import { PaTierBreakdownComponent } from './pages/kenya/pa-tier-breakdown/pa-tier-breakdown.component';
import { StudentPaKycComponent } from './pages/kenya/student-pa-kyc/student-pa-kyc.component';

import { DpQuoteComponent } from './pages/kenya/domestic-package/quote/quote.component';
import { DpPersonalDetailsComponent } from './pages/kenya/domestic-package/personal-details/personal-details.component';
import { DpBuildingDetailsComponent } from './pages/kenya/domestic-package/building-details/building-details.component';
import { DpImeiDetailsComponent } from './pages/kenya/domestic-package/imei-details/imei-details.component';
import { DpClaimComponent } from './pages/kenya/domestic-package/claim/claim.component';




@NgModule({
  declarations: [
    AppComponent,
    QuoteDetailsComponent,
    KycComponent,
    ClaimDetailsComponentUG,
    YearDateFormatDirective,
    FullYearDateFormatDirective,
    ClaimComponentTZ,
    Page2Component,
    Page3Component,
    Page4Component,
    QuoteDetailsUGComponent,
    ClaimDetailsComponent,
    ConfirmComponent,
    BenefitsComponent,
    DetailsTZComponent,
    DetailsComponent,
    ClaimComponent,
    TheftDetailsComponent,
    PesapalWebhookComponent,
    PesapalPayComponent,
    FnolComponent,
    BuyComponent,
    SspLoginComponent,
    PaTierBreakdownComponent,
    StudentPaKycComponent,

    DpQuoteComponent,
    DpPersonalDetailsComponent,
    DpBuildingDetailsComponent,
    DpImeiDetailsComponent,
    DpClaimComponent,


  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
     ToastrModule.forRoot({     // global config (optional)
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    AppRoutingModule,
    MatCardModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatMomentDateModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    
    NgDompurifyModule,
    
    HttpClientModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatStepperModule
  ],
  providers: [
    ApiCallService,
    CurrencyPipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: FULL_FORMAT },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
